<template>
  <div class="box1">
    <div v-loading="loading" class="box_1">
      <!-- 里面写eleCalendar组件-->
      <ele-calendar :render-content="renderContent" :disabled-date="disabledDate" :data="datedef" :prop="prop" value-format="yyyy-MM-dd" :border="true" class="calendar calendar1" @pick="clickpick" @date-change="dateChange" />
    </div>
    <div v-if="rightbox" class="rightbox">
      <div class="rightboxbottom">
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="68px" class="demo-ruleForm">
          <el-form-item :label="$t('fleet.Typeofoperation')">
            <el-radio-group v-model="ruleForm.data.type">
              <el-radio label="1">{{ $t('fleet.increase') }}</el-radio>
              <el-radio label="-1">{{ $t('fleet.reduce') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('hotel.Stock')" prop="data.stock">
            <el-input v-model.number="ruleForm.data.stock" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">{{ $t('hotel.immediatesubmission') }}</el-button>
            <el-button @click="resetForm('ruleForm')">{{ $t('hotel.reset') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>

</template>

<script>
import base from './base'

export default {
  extends: base,
  data() {
    return {
      datas: {
        data: {
          hotel_id: '1',
          room_id: '6',
          date: ''
        },
        client_type: 'pc'
      },
      ruleForm: {
        client_type: 'pc',
        data: {
          room_id: '6',
          stock: '',
          type: '1',
          date: ''
        }
      }
    }
  }
}
</script>

<style>
/* .calendar1 td > div > div {
  padding-bottom: 10px;
}
.calendar1 td > div > div > div:last-child {
  display: none;
  margin-bottom: 10px;
} */
</style>
